import { MetroMoscow16, MetroSpb16 } from '@cian/ui-kit/icons';
import * as React from 'react';

export interface IIconsMetro {
  type?: string;
}

export const IconsMetro: React.FC<IIconsMetro> = ({ type }) => {
  switch (type) {
    case 'spb':
      return <MetroSpb16 color="current_color" />;

    default:
      return <MetroMoscow16 color="current_color" />;
  }
};

IconsMetro.displayName = 'IconsMetro';
